export class DateDptRequest {
    date : Date;
    deptName : string;
}